import React from "react";
import moment from "moment";
import { Tooltip } from "antd";
import { UnderlyingContent, TableLabel } from '../../styles';
import RecurringIcon from "../../../../../../assets/icons/recurring.svg";
import GaIcon from "../../../../../../assets/icons/grant-agreement.svg";
import { formatAmount } from "../../../../../../utils/commonUtil";
import { dateSorter, basicSorter } from "../../../../../../utils/sorter";
import {recognitionType} from "../../../RecommendGrant/utils";

const columns = (grantDetailsHandler) => [
  {
    title: "",
    dataIndex: "",
    key: "recurringGrant",
    render: (value, record) => {
      if (record.isRecurring) {
        return (
          <Tooltip placement="bottomLeft" title="Recurring Grant Schedule">
            <img className="pointer" src={RecurringIcon} alt="RecurringIcon" />
          </Tooltip>
        );
      } else if (record.grantAgreement) {
        return (
          <Tooltip placement="bottomLeft" title="Grant Agreement">
            <img className="pointer" src={GaIcon} alt="GaIcon" />
          </Tooltip>
        );
      }
    }
  },
  {
    title: "Transaction ID",
    dataIndex: "transactionId",
    key: "transactionId",
    sortDirections: ["ascend", "descend"],
    sorter: (a ,b) => basicSorter(a.transactionId, b.transactionId),
    render: value => (<UnderlyingContent onClick={() => grantDetailsHandler(value, "single")}>{value}</UnderlyingContent>),
  },
  {
    title: "Issued Date",
    dataIndex: "receiveDate",
    key: "receiveDate",
    sortDirections: ["ascend", "descend"],
    sorter: (a, b) => dateSorter(moment(a.receiveDate, "MM/DD/YYYY"), moment(b.receiveDate, "MM/DD/YYYY")),
    render: value => (<TableLabel>{value}</TableLabel>),
  },
  {
    title: "Amount",
    dataIndex: "grantAmount",
    key: "grantAmount",
    sortDirections: ["ascend", "descend"],
    sorter: (a, b) => basicSorter(parseFloat(a.grantAmount), parseFloat(b.grantAmount)),
    render: value => (<TableLabel>{formatAmount(value)}</TableLabel>),
  },
  {
    title: "Purpose",
    dataIndex: "grantPurpose",
    key: "grantPurpose",
    sortDirections: ["ascend", "descend"],
    sorter: (a ,b) => basicSorter(a.grantPurpose, b.grantPurpose),
    render: value => (<TableLabel>{value}</TableLabel>),
  },
  {
    title: "Recognition",
    dataIndex: "recognitionOptions",
    key: "recognitionOptions",
    sortDirections: ["ascend", "descend"],
    sorter: (a ,b) => basicSorter(a.grantRecognition, b.grantRecognition),
    render: value => (<TableLabel>{value.recognitionId && recognitionType[value.recognitionId]}</TableLabel>),
  }
];

export default columns;
